const HelpModalError = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M16 11.6668V17.0002M16 20.6668V20.6535M13.7079 4.85507L3.72924 21.6373C2.67232 23.4149 3.9533 25.6668 6.02134 25.6668H25.9786C28.0466 25.6668 29.3276 23.4149 28.2707 21.6373L18.2921 4.85507C17.2584 3.11667 14.7415 3.11667 13.7079 4.85507ZM16.3333 20.6668C16.3333 20.8509 16.1841 21.0002 16 21.0002C15.8159 21.0002 15.6666 20.8509 15.6666 20.6668C15.6666 20.4828 15.8159 20.3335 16 20.3335C16.1841 20.3335 16.3333 20.4828 16.3333 20.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default HelpModalError
